import { render, staticRenderFns } from "./MiningMachine.vue?vue&type=template&id=39bef920&scoped=true"
import script from "./MiningMachine.vue?vue&type=script&lang=js"
export * from "./MiningMachine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bef920",
  null
  
)

export default component.exports